import type { RootStore } from '@/store'
import type { StateCreator } from 'zustand'

export interface SessionStore {
	lastOpenedAt?: number
	setLastOpenedAt: (value: number) => void
}

export const createSessionSlice: StateCreator<RootStore, [], [], SessionStore> = (
	set
) => ({
	lastOpenedAt: undefined,
	setLastOpenedAt: (value) => set({ lastOpenedAt: value }),
})

export const sessionStoreSelector = (state: RootStore) => ({
	lastOpenedAt: state.lastOpenedAt,
	setLastOpenedAt: state.setLastOpenedAt,
})
